import React, { useState } from 'react'

import HeroSelect from 'components/heroSelect';
import { GameType, StagePack } from 'draft/types';
import { Participant } from 'tour/types';
import { getHeroBasedOnName } from 'draft/heroes/useHeroes';
import { Button, Modal } from 'semantic-ui-react';

import StageSelect from 'components/stageSelect';


type Props = {
    isOpen: boolean,
    close: () => void,
    applyManualDraft: (stage : string, updatedParticipants: Participant[]) => void;
    gameType: GameType
    stagePack: StagePack
    players: Participant[]
}

const ManualDraftModal = ({ isOpen, close, applyManualDraft, players, gameType, stagePack }: Props) => {
    const [selectedStage, setSelectedStage] = useState<string>('');
    const [selectedHeroes, setSelectedHeroes] = useState<string[]>([])

    const getPlayerIndex = (player: Participant) : number => {
        for(let i = 0; i < players.length; i++){
            if(player.Number === players[i].Number) return i;
        }
        return -1;
    }

    const getSelectedHeroForPlayer = (player: Participant): string => selectedHeroes[getPlayerIndex(player)];

    const setNewHeroToPlayer = (player: Participant, newHero: string): void => {
        let temp = [...selectedHeroes]
        const index = getPlayerIndex(player);
        temp[index] = newHero;
        setSelectedHeroes(temp);
    }

    const playerHeroSelect = (player: Participant, index : number) => {
        const onChange = (newHeroName: string) => {
            setNewHeroToPlayer(player, newHeroName)
        }   

        const team = index <= 1 ? 'red' : 'blue';

        return (
            <div style={{ marginTop: '1.5em', textAlign:'left'}}>
                <div style={{marginBottom: '0.5em'}}>
                    <h4>{player.Name}</h4>
                </div>
                <HeroSelect
                    heroName={getSelectedHeroForPlayer(player)}
                    team={team}
                    gameType={gameType}
                    onChange={onChange}
                ></HeroSelect>
            </div>
        )
    }

    const stageOnSelect = (newStage : string) => {
        setSelectedStage(newStage)
    }

    const onSave = () => {
        if(!formOK){
            console.error("A player is missing a hero");
            return;
        }
            
        players.forEach(p => {
            const heroName = getSelectedHeroForPlayer(p);
            p.Hero = getHeroBasedOnName(heroName, gameType);
        })

        applyManualDraft(selectedStage, players);
    }

    const formOK = () : boolean => {
        let ok = true;
        for(let i = 0; i < 4; i++){
            if(!selectedHeroes[i]){
                ok = false;
                break;
            }
        }
        return ok;
    }

    return (
        <Modal
            open={isOpen}
            onClose={() => close()}
            style={{ textAlign: 'center' }}
            className='melee-modal'
        >
            <Modal.Content>
                    <h2>Manual Add Draft</h2>
                    <div style={{ 'margin': '4em 0 0em 0'}}>
                        <StageSelect
                                gameType={gameType}
                                stagePack={stagePack}
                                onChange={stageOnSelect}
                        />
                    </div>

                    <div style={{
                        'display': 'flex',
                        'flexDirection' : 'column',
                        'alignItems' : 'center',
                        'margin': '0 0 4em 0',
                    }}>
                        
                        
                        {
                            players.map((p, index) => playerHeroSelect(p, index))
                        }
                    </div>
                <div style={{marginTop: '1.5em'}}>
                    <Button inverted color='yellow' onClick={onSave}>Save</Button>
                    <Button inverted color='grey' onClick={close}>Cancel</Button>
                </div>
            </Modal.Content>
        </Modal>
    )
}

export default ManualDraftModal;